import { AbstractServiceRecord } from './abstract-service-record';
import { DataType } from '@common/enums/data-type';
import { IServiceCollectionScript } from '@common/interfaces/i-service-collection-script';
import { IServiceCollectionRecord } from '@common/interfaces/i-service-collection-record';
import { ServiceCollectionFactory } from '@common/data-models/service/service-collection-factory';
import { KnownPropertyTypes } from '@common/enums/known-property-types';

let metaData = {
    HasPendingChanges: DataType.BOOL,
    LTTRecording: DataType.BOOL,
    OnAir: DataType.BOOL,
    SuspendRowFlashing: DataType.BOOL,
    TimeFormat: DataType.NUMBER,
    UpdatesSuspended: DataType.BOOL
};

KnownPropertyTypes.setFor(metaData);

export class ServiceCollectionRecord extends AbstractServiceRecord implements IServiceCollectionRecord {
    public CollectionScripts: Array<IServiceCollectionScript>;
    public HasPendingChanges?: boolean;
    public LTTRecording?: boolean;
    public OnAir?: boolean;
    public SuspendRowFlashing?: boolean;
    public TimeFormat?: number;
    public UpdatesSuspended?: boolean;
    public RemovedScripts?: Array<string>;

    public getOwnMetaData(): { [id: string]: number } {
        let objectKeys = Object.keys(this);
        let ret = {};
        for (let prop of objectKeys) {
            if(metaData[prop]) ret[prop] = metaData[prop];
        }
        return (ret);
    }

    public getMetaData(): { [id: string]: number } {
        let ret = this.getOwnMetaData();
        let parentMetaData = super.getMetaData();

        // merge
        for (let p in parentMetaData) {
            if (!ret[p]) ret[p] = parentMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getOwnMetaData()[field]) {
            return this[field];
        } else return super.getRawValue(field);
    }

    public static instance(data: any): ServiceCollectionRecord {
        let ret: ServiceCollectionRecord = Object.assign(ServiceCollectionFactory.newServiceCollectionRecord(), data);
        if (ret.CollectionScripts) {
            for (let i in ret.CollectionScripts) {
                ret.CollectionScripts[i] = Object.assign(ServiceCollectionFactory.newServiceCollectionScript(), ret.CollectionScripts[i]);
                ret.CollectionScripts[i].instantiateChildren();
            }
            ret.instantiateChildren();
        }
        return ret;
    }
}

ServiceCollectionFactory.newServiceCollectionRecord = () => {
    return new ServiceCollectionRecord();
};
